module.exports = __webpack_public_path__ + "media/icons/offer-details-osobowe@2x-885b13d0.png";